import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import {
  profileInfoDetailBlockSx,
  profileInfoDetailLabelSx
} from '../constants/profileInfoConstants'

export default function ProfileInfoDetailBlock({ label, children }) {
  return (
    <Box sx={profileInfoDetailBlockSx}>
      <Typography sx={profileInfoDetailLabelSx}>{label}</Typography>
      {children}
    </Box>
  )
}
